import React from 'react'
import LineClockDollarIcon from 'LuxKit/Icons/line/LineClockDollarIcon'
import Pill from 'LuxKit/Pill'

function PayLaterPill() {
  return (
    <Pill startIcon={<LineClockDollarIcon />} kind="tertiary" variant="primary">
      Pay later
    </Pill>
  )
}

export default PayLaterPill
